import React, { useEffect, useState } from "react";
import { getAllDocsSnap } from "../../../utils/firebase/Firebase.utils";
import ParkingCard from "./ParkingCard";

export default function Parking({ searchTerm = "", statusFilter = "all" }) {
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchParkingSpaces = async () => {
      await getAllDocsSnap("parkingSpaces", (data) => {
        setParkingSpaces(data);
        setLoading(false);
      });
    };
    fetchParkingSpaces();
  }, []);

 

  // First filter by status if specified
  const statusFilteredParkingSpaces =
    statusFilter === "all"
      ? parkingSpaces
      : parkingSpaces.filter(
          (parking) =>
            parking.status === statusFilter ||
            (statusFilter === "active" && !parking.status) // Items with no status are considered active by default
        );

  // Then filter by search term
  const filteredParkingSpaces =
    searchTerm.trim() === ""
      ? statusFilteredParkingSpaces
      : statusFilteredParkingSpaces.filter((parking) => {
          const searchLower = searchTerm.toLowerCase();
          return (
            parking.title?.toLowerCase().includes(searchLower) ||
            parking.description?.toLowerCase().includes(searchLower) ||
            parking.location?.toLowerCase().includes(searchLower) ||
            parking.price?.toString().includes(searchLower)
          );
        });

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <div>
      {filteredParkingSpaces.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-gray-600">
            {searchTerm.trim() !== ""
              ? `No parking spaces found matching "${searchTerm}"`
              : statusFilter !== "all"
              ? `No ${statusFilter} parking spaces available at the moment.`
              : "No parking spaces available at the moment."}
          </p>
        </div>
      ) : (
        <div>
          {filteredParkingSpaces.map((parking, index) => (
            <ParkingCard data={parking} key={parking.id || index} />
          ))}
        </div>
      )}
    </div>
  );
}
